import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import Card from "./Components/Card";
import Header from "../../components/Header/Header";
import { options } from "../../models/Home";
import { crm } from "../../theme";
import { useEffect, useState } from "react";
import { getProcessById } from "../../services/processService";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { hasScreenAccess } from "../../utils/screens";

const Home = () => {
  const auth = useAuthUser<any>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getProcessById("");
    setTimeout(() => {
      setLoading(false);
    }, 400);
  }, []);
  return (
    <Box height="100vh" overflow={"hidden"} fontFamily="Inter">
      <Header isHome />
      <Flex
        height="90vh"
        alignItems="center"
        flexDirection="column"
        backgroundColor="var(--main-bg-color)"
        paddingBottom="32px"
      >
        <Box zIndex={1} overflowX="auto">
          <Text
            fontWeight="normal"
            fontSize="34px"
            mt={{ base: "64px", md: "120px" }}
            mb={{ base: "16px", md: "32px" }}
            size="lg"
            px="16px"
            textAlign="center"
            color={crm.text}
          >
            Olá {auth?.firstname}, o que faremos hoje?
          </Text>
          <Flex w="100vw" justifyContent="center">
            <Flex
              gap="12px"
              flexDir={{ base: "column", md: "row" }}
              flexWrap="wrap"
              alignItems="center"
              justifyContent="center"
              overflowX="auto"
              opacity={loading ? 0 : 1}
            >
              {options
                .filter((o) =>
                  auth?.position === 0 || auth?.position === 1
                    ? ["/dashboard", "/documents", "/processes", "/financial"].includes(
                        o.link,
                      )
                    : auth?.position > 1 ||
                      (o.link !== "/processes-status" &&
                        o.link !== "/purchaseOrders" &&
                        o.link !== "/commercial" &&
                        o.link !== "/report"),
                )
                .filter((o) => hasScreenAccess(auth, o.link))
                .map((option) => (
                  <Box key={option.link}>
                    <Card {...{ option }} />
                  </Box>
                ))}
            </Flex>
          </Flex>
        </Box>
      </Flex>
    </Box>
  );
};
export default Home;
